import { createContext } from 'react';

import { Platform } from '../types';

const PlatformContext = createContext<Platform['name'] | undefined>(undefined);

export default PlatformContext;
